import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { UnlinkCardConfirmModalProps } from './UnlinkCardConfirmModal.types';

export const renderUnlinkCardConfirmModal = (data?: UnlinkCardConfirmModalProps) =>
    openPopupHelper({ popupName: popupNames.UNLINK_CARD_CONFIRM_MODAL, data, onClose: data?.onClose });

export const closeUnlinkCardConfirmModal = () => closePopupHelper(popupNames.UNLINK_CARD_CONFIRM_MODAL);
